import {
  DataTable,
  DataTableColumn,
  DataTableOptions,
  DataType,
  DecimalScale,
  FilterType,
  UserPermission
} from '@globaleris/ui.library'
import { Pageview } from '@material-ui/icons'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { NonAuthRoutes } from '../../../model'
import { getCustomerDomain } from '../../../redux'
import { VirtualBatteryBalanceTableModel } from '../floatingConcepts.model'

type FloatingConceptsVirtualBatteryTabProps = {
  tableData: VirtualBatteryBalanceTableModel[]
  getVirtualBatteryList: () => Promise<void>
}

export const FloatingConceptsVirtualBatteryTab: React.FC<
  FloatingConceptsVirtualBatteryTabProps
> = ({ tableData, getVirtualBatteryList }) => {
  const [t] = useTranslation(['globalerisLibrary', 'enums', 'floatingConcepts'])
  const history = useHistory()

  // #region Handlers Starts
  const onViewDetailsClickHandler = (row: VirtualBatteryBalanceTableModel) => {
    history.push(NonAuthRoutes.virtualBatteryDetail, { ...row })
  }
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  const options: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    search: true,
    elevation: 1,
    filterType: FilterType.ADVANCED,
    download: true,
    canEdit: false,
    canDelete: false,
    canInsert: false,
    customInsertEditModal: true,
    analytics: {
      customer: getCustomerDomain(),
      view: t('floatingConcepts:dataTable.analytics')
    },
    rowCustomActions: [
      {
        userPermission: UserPermission.EDIT,
        icon: <Pageview fontSize="small" />,
        tooltip: t('floatingConcepts:dataTable.customActions.detail'),
        onClick: onViewDetailsClickHandler
      }
    ]
  }

  const columns: DataTableColumn[] = [
    {
      name: 'id',
      display: false
    },
    {
      name: 'subjectId',
      label: t('floatingConcepts:dataTable.columns.subject'),
      type: DataType.TEXT,
      display: false
    },
    {
      name: 'subjectDescription',
      label: t('floatingConcepts:dataTable.columns.subject'),
      type: DataType.TEXT
    },
    {
      name: 'contractId',
      label: t('floatingConcepts:dataTable.columns.contract'),
      type: DataType.TEXT,
      display: false
    },
    {
      name: 'settlementGroupId',
      label: t('floatingConcepts:dataTable.columns.settlementGroup'),
      type: DataType.TEXT,
      display: false
    },
    {
      name: 'codeColumn',
      label: t('floatingConcepts:dataTable.columns.codeColumn'),
      type: DataType.TEXT
    },
    {
      name: 'balance',
      label: t('floatingConcepts:dataTable.columns.availableBalance'),
      type: DataType.NUMBER,
      decimalScale: DecimalScale.DEFAULT
    }
  ]
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  useEffect(() => {
    getVirtualBatteryList()
  }, [])
  // #endregion Hooks Ends

  return (
    <>
      <DataTable
        data={tableData}
        columns={columns}
        options={options}
        // userPermissions={getUserPermissions(Pages.VirtualBatteryDetail)}
      />
    </>
  )
}
